<template>
    <div id="mySidenav" ref="mySidenav" class="sidenav">
        <!-- 
        <a class="close-btn" @click="closeNav">
            <i class="far fa-times" aria-hidden="true"></i>
        </a> 
        -->
        <router-link :to="{ name: 'ChangeInfo' }" class="info-btn">
            <!-- <i class="far fa-info" aria-hidden="true"></i> -->
            <img :src="ProfileData" alt="profile">
        </router-link>

        <a class="logout-btn" @click="logout" v-if="name">
            <!-- <i class="fa fa-sign-out-alt" aria-hidden="true"></i> -->
            <img class="auth-icon" :src="SignOut" alt="SignOut">
        </a>
        <router-link class="login-btn" :to="{ name: 'Login' }" v-else>
            <!-- <i class="fa fa-sign-in-alt" aria-hidden="true"></i> -->
            <img class="auth-icon" :src="SignIn" alt="SignIn">
        </router-link>

        <div 
          class="profile-container"
          :style="{ 'background-image': 'url(' +  PC + ')' }"
        >
            <label 
                  v-if="name"
                  for="pic-upload" class="pic-label"
                  :style="{ 'background-image': 'url(' + URL + '/' + profilePic + ')' }"
              >
                  <i class="fal fa-plus-circle" aria-hidden="true"></i>
            </label>
            <input id="pic-upload" type="file" @change="onChangeImage" ref="coverId"/>

            <span class="user" v-if="name">{{ name }}</span>
        </div>

        <router-link 
          v-if="credit != undefined"
          class="wallet-banner"
          :to="{ name: 'MyWealth' }"
        >
          <img class="my-wealth-img" :src="HB" alt="hb">

          <span class="title">سرمایه من</span>
          <span class="price" v-if="credit != 0">{{ credit | comma }} تومان</span>
          <span class="price" v-else>0 تومان</span>
        </router-link>

        <button 
            @click="ShowContact"
            class="btn btn-outline-dark contact-btn"
        >تماس با ما</button>

        <div 
          v-if="name"
          class="btn-container container"
        >
          <div class="row">
            <router-link 
              tag="button" :to="{ name: 'MyCourses' }"
              class="btn btn-light my-btn"
              style="padding: 0 5pt;"
            >
              <img :src="Hat" alt="Hat">
            </router-link>
            <div class="seperator"></div>
            <router-link 
              tag="button" :to="{ name: 'Notifications' }"
              class="btn btn-light my-btn" style="position: relative;"
            >
              <span class="unread-num" v-if="unread">{{ unread }}</span>
              <img :src="Msgs" alt="Hat">
            </router-link >

            <span class="title">دوره‌های من</span>
            <span class="title">پیام‌های من</span>
          </div>
        </div>

        <!-- <div class="sharethis-inline-share-buttons share-btn"></div> -->
        <div class="share-btns">
            <a href="https://api.whatsapp.com/send?phone=+989127337686" class="btn btn-success share-btn">
              <i class="fab fa-whatsapp"></i>
            </a>
            <a href="https://telegram.me/Rahaashrafi" class="btn btn-info share-btn">
              <i class="fab fa-telegram-plane"></i>
            </a>
        </div>
    </div>
</template>

<script>
import Hat from '@/assets/images/sidenav/hat.png';
import Msgs from '@/assets/images/sidenav/msgs.png';
import HB from '@/assets/images/sidenav/hoviat_basari.png';
import PC from '@/assets/images/sidenav/profile-container.png';

import SignIn from '@/assets/images/sign-in-green.svg';
import SignOut from '@/assets/images/sign-out-red.svg';

import ProfileData from '@/assets/images/khanesh/profile-data.png';

import { getRequest, postRequest, APP_API_URL } from '@/utils/libs/api-request';

import Cookies from 'js-cookie';
const uniqid = require('uniqid');

export default {
    name: 'SideNav',
    data() {
        return {
            PC: PC,
            HB: HB,
            Hat: Hat,
            Msgs: Msgs,

            userId: undefined,
            SignIn: SignIn,
            SignOut: SignOut,

            ProfileData: ProfileData,

            label: undefined,
            loading: false,
            URL: APP_API_URL(),
            profilePic: undefined,

            name: undefined,
            credit: undefined,

            unread: 0,
        }
    },
    watch: {
        '$route'() {
            let name = this.$route.name;
            if(name == 'Khanesh') this.GetUser();

            this.GetNotif();
        }
    },
    mounted() {
        this.GetUser();
        this.GetNotif();
        this.$root.$refs = {...this.$refs, ...this.$root.$refs};
    },
    methods: {
        onChangeImage() {
            this.lable = this.$refs['coverId'].files[0].name

            this.submit();
        },

        submit() {
            if(this.loading) return;
            else this.loading = true;

            this.$emit('alertMsg', 
                { message: 'بارگذاری تصویر در حال انجام است', key: uniqid(), type: 'success' }
            )

            const formData = new FormData();

            formData.append('cover', this.$refs['coverId'].files[0])

            postRequest('/users/upload-pic', formData)
                .then((rsp) => {
                    let data = rsp['data'];
                    this.profilePic = data.ProfilePic;

                    this.$emit('alertMsg', 
                        { message: 'بارگذاری تصویر تکمیل گردید', key: uniqid(), type: 'success' }
                    )

                })
                .catch((err) => {
                    // error
                    if(err.response) {
                        this.$emit('alertMsg', 
                            { message: err.response.data.message, key: uniqid(), type: 'error' }
                        )
                    }
                })
                .finally(() => {
                    this.loading = false;
                    this.lable = undefined;
                });
        },
        GetUser() {
            getRequest('/users/user')
                .then(rsp => {
                    // response
                    let data = rsp['data'];
                    this.name = data.FirstName + ' ' + data.LastName;
                    this.credit = data.Credit;
                    this.profilePic = data.ProfilePic;
                    this.userId = data._id;
                })
                .catch(() => {
                    // error
                });
        },
        logout() {
            if (Cookies.get('access_cookie')) {
                postRequest('/users/logout')
                    .then(() => {
                        // response
                        Cookies.remove('access_cookie')
                        this.$router.push({ name: 'Login' })

                        location.reload();
                    })
                    .catch(() => {
                        // error
                    });
            } else {
                this.$router.push({ name: 'Login' })
            }
        },
        GetNotif() {
            getRequest('/notifications/find-all')
                .then(rsp => {
                    // response
                    this.unread = 0;

                    (rsp.data).forEach(msg => {
                        if((msg.CleanUsers || []).indexOf(this.userId) == -1) {
                            this.unread += 1;
                        }
                    });
                })
                .catch(err => {
                    // check auth
                    if (err.response) {
                        if (err.response.status == 401) {
                            // Cookies.remove('access_cookie');
                            // this.$router.push({ name: 'Login' });
                        }
                    }
                });
        },
        closeNav() {
            document.getElementById('mySidenav').style.width = '0';
        },
        ShowContact() {
            this.$modal.show('dialog', {
                title: 'اطلاعات تماس',
                text: `
                  <br/>
                  آدرس: تهران، خیابان شریعتی، بالاتر از پل صدر، روبروی ایستگاه مترو، خیابان اخوان، پلاک ۱۰، طبقه ۳
                  <br/>
                  شماره تماس: ۰۲۱۲۶۷۶۸۶۶۰ - ۰۲۱۲۶۷۶۸۶۱۶
                  <br/>
                  شماره پشتیبانی: ۰۹۱۲۷۳۳۷۶۸۶
                  <br/>
                  وب سایت: iservat.ir
                  <br/><br/>
                `,
                buttons: [
                    {
                        title: 'مشاهده شد',
                        default: true,
                    }
                ]
            });
        },
    }
}
</script>

<style scoped>
.unread-num {
  background-color: #fa6b0b;
    color: #fff;
    width: 20px;
    height: 20px;
    display: block;
    font-size: 15px;
    border-radius: 4px;
    position: absolute;
    top: 5px;
    right: 5px;
}

/* ---------------------------------------- */
/* --------------- GENERAL ---------------- */
/* ---------------------------------------- */
.sidenav {
  height: 100%;
  width: 0;
  padding: 5pt 0pt 10pt;

  position: fixed;
  z-index: 1033;
  top: 0;
  right: 0;
  
  text-align: right;
  border-top-left-radius: 25pt;
  background-color:   #f1f2f6;
  
  overflow-x: hidden;
  transition: 0.5s;
}
.sidenav .auth-icon {
  height: 25px;
  width: 25px;
}
.sidenav .contact-btn {
  height: 50px;
  width: calc(100% - 20px);
  margin: 10px 10px 0;
}
.sidenav .share-btns {
  padding: 0;

  display: flex !important;
  flex-wrap: wrap;
}
.sidenav .share-btns .share-btn {
  color: #fff;

  margin: 25px auto 0;
  padding: 2px 12px;

  font-size: 33px;
}
.sidenav .share-btns .share-btn i {
  vertical-align: middle;
}

/* ---------------------------------------- */
/* ----------------- A TAG ---------------- */
/* --------------- CLOSE BTN -------------- */
/* ---------------------------------------- */
.sidenav a {
  padding: 8pt 8pt 0pt 6pt;
  text-decoration: none;
  font-size: 1rem;
  color: #ccc;
  display: block;
  transition: 0.3s;

  direction: rtl;
}
.sidenav a:hover,
.selected {
  color: #eee !important;
  cursor: pointer;
}
.sidenav .logout-btn,
.sidenav .login-btn,
.sidenav .info-btn,
.sidenav .close-btn {
  position: absolute;
  top: 9pt;
  font-size: 1.25rem;
}
.sidenav .close-btn {
  left: 14pt;
}
.sidenav .info-btn {
  /* left: calc(20pt + 1.25rem); */
  left: 14pt;
}
.sidenav .info-btn img {
  width: 1.25rem;
  margin-top: 0;
  margin-bottom: 6pt;
}
.sidenav .logout-btn {
  right: 14pt;
  color: #fa6b0b;
}
.sidenav .login-btn {
  right: 10pt;
  top: 7pt;
}
@media screen and (max-height: 396pt) {
  .sidenav a { font-size: 0.75rem; }
}

/* ---------------------------------------- */
/* ---------------- PROFILE --------------- */
/* ---------------------------------------- */
.sidenav .profile-container {
  height: 170pt;
  width: calc(100% - 10pt);
  margin: 0 5pt;

  border-radius: 15pt;

  background-color: #3d4a8e;

  background-position: center bottom;
  background-size: contain;
  background-repeat: no-repeat;
}
.sidenav .profile-container #pic-upload {
  display: none;
}
.sidenav .profile-container .user,
.sidenav .profile-container .pic-label {
  color: #f1f2f6;
  text-align: center;
}
.sidenav .profile-container .user {
  width: 100%;
  display: inline-block;
}
.sidenav .profile-container .pic-label {
  width: 50pt;
  height: 50pt;
  margin: 35pt 60pt 5pt;
  padding: 8pt 0;

  font-size: 28pt;
  border-radius: 50%;

  background-color: #016fa0;

  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}

/* ---------------------------------------- */
/* ------------- SIDENAV BTNs ------------- */
/* ---------------------------------------- */
.sidenav .btn-container .seperator {
  margin: 10pt 0;
  border: 1px solid #ccc;
}
.sidenav .btn-container .my-btn {
  height: 45pt;
  width: 45pt;

  margin: 10pt auto;
  padding: 0 10pt;

  border: 2pt solid #fff;
  box-shadow: 3px 3px 4pt 2pt #ddd;
}
.sidenav .btn-container .my-btn img {
  max-width: 100%;
  max-height: 100%;
}
.sidenav .btn-container .title {
  width: 90pt;
  margin: auto;

  font-size: .75rem;
  font-weight: bold;

  text-align: center;
  display: inline-block;
}

/* ---------------------------------------- */
/* ------------- WALLET BANNER ------------ */
/* ---------------------------------------- */
.sidenav .wallet-banner {
  height: 100pt;
  width: 170pt;

  margin: 10pt 5pt;
  padding: 20pt 15pt;

  border-radius: 15pt;

  position: relative;
  background-color: #2ad85f;
  box-shadow: 3px 3px 5px #44ef78;
}
.sidenav .wallet-banner .my-wealth-img {
  width: 80%;
  position: absolute;
  left: 0;
  bottom: 0;
  border-bottom-left-radius: 15px;
  filter: hue-rotate(25deg) brightness(0.8);
}
.sidenav .wallet-banner .title {
  color: #fff;
  font-weight: bold;

  display: block;
  position: relative;
}
.sidenav .wallet-banner .price {
  width: 100%;

  text-align: center;
  display: block;
  position: relative;

  color: #fff;
  font-size: 1.75rem;
}
</style>
